import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export function labeledText(rows: Array<[string, string]>): string {
  return rows
    .filter(([, value]) => value.trim())
    .map(([label, value]) => `${label}: ${value.trim()}`)
    .join('\n');
}

const CopyButton: React.FC<{ label: string; text: string; onCopied: (ok: boolean) => void }> = ({ label, text, onCopied }) => (
  <Tooltip title="Kopiera">
    <span>
      <IconButton size="small" aria-label={`Kopiera ${label}`} disabled={!text} onClick={async () => onCopied(await copyText(text))} sx={{ p: 0.5 }}>
        <ContentCopyIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </span>
  </Tooltip>
);

export default CopyButton;
